import React from "react";
const cx = (...a) => a.filter(Boolean).join(" ");
export default function Card({ className, ...props }) {
  return <section className={cx("card", className)} {...props} />;
}
